import Section from '../Section';
import KenBurns from '../global/KenBurns';

export default class ImageGallery extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);
  }
}
